import { Link } from "react-router-dom";
import { faqGroups } from "@/mocks/faq";
import FaqAccordion from "@/components/feature/FaqAccordion";

export default function FaqPreview() {
  const items = [...faqGroups[0].items.slice(0, 3), faqGroups[1].items[0]];

  return (
    <section className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16" aria-labelledby="home-faq-title">
      <div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14">
        <div>
          <p className="text-xs font-medium tracking-[0.25em] text-primary-600">FAQ</p>
          <h2 id="home-faq-title" className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            常见问题
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            关于搜索技巧、标签与分类的差别、词条如何更新，这里都写了。还有别的问题可以去完整问答页看看。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-foreground-950 px-5 py-2.5 text-sm text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50"
          >
            查看全部问答
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <FaqAccordion items={items} />
      </div>
    </section>
  );
}